import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import './plugins/element.js'
import router from "./router.js"
import store from "./store"
import * as excels from './plugins/excel'
import xaoi from "./common/xaoi.js"
import dataV from '@jiaminghi/data-view';
import './assets/scss/style.scss';
import './utils/directives/el-select-loadmore'
import {} from "./assets/iconfont/iconfont.css";
import Cookie from './utils/Cookie'

import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons/chart-bar.js';
import 'vue-awesome/icons/chart-area.js';
import 'vue-awesome/icons/chart-pie.js';
import 'vue-awesome/icons/chart-line.js';
import 'vue-awesome/icons/align-left.js';
Vue.component('icon', Icon);
Vue.use(dataV);

window.xaoi = xaoi;

window._ = console.log
Vue.prototype.$excels = excels;
Vue.prototype.$cookie = Cookie;
import xaoi_win from "./components/xaoi/win.vue"
Vue.component('xaoi-win', xaoi_win)

import xaoi_page from "./components/xaoi/page.vue"
Vue.component('xaoi-page', xaoi_page)

import xaoi_img from "./components/xaoi/img.vue"
Vue.component('xaoi-img', xaoi_img)


import 'vue-happy-scroll/docs/happy-scroll.css'
// 移动端滚动插件
import vuescroll from 'vuescroll';
Vue.use(vuescroll);
Vue.prototype.bus = new Vue();

// Vue.prototype.ajax = xaoi.ajax(function () {
// 	this.url = '/admin/pc/' + this.url
// 	var user = xaoi.session('user')
// 	if (user) this.header('token', user.token)
// 	this.header('Content-Type', 'application/json;charset=UTF-8')
// 	this.data = JSON.stringify(this.data)
// }, function () {});



Vue.prototype.ajax2 = xaoi.ajax(function () {
	this.url = '/admin/pc/' + this.url
	var user = xaoi.session('user')
	if (user) this.header('token', user.token)
}, function (res) {
	return res.data;
});


// 引入api
import * as http from './api/api'
Vue.prototype.$http = http;

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import china from 'echarts/map/json/china.json' // 引入json文件
echarts.registerMap('china', china) // 在echarts中注册使用这个文件


import {
	Message
} from 'element-ui'

let loading = null
let requestCount = 0
// 显示loading
function showLoading() {
	if (requestCount === 0) {
		loading = Message({
			message: '加载中...',
			duration: 0
		});
	}
	requestCount++
}
// 隐藏loading
function hideLoading() {
	if (requestCount > 0) {
		requestCount--
	}
	if (loading && requestCount === 0) {
		loading.close()
	}
}

// 添加请求拦截器
axios.interceptors.request.use((config) => {
	// console.log(config);
	// 添加header头的token
	let token = window.sessionStorage.getItem('token')
	if (config.token === true) {
		config.headers['token'] = token
	}
	// 显示loading
	if (config.loading === true) {
		showLoading()
	}
	// 在发送请求之前做些什么
	return config;
}, (error) => {
	// 隐藏loading
	hideLoading()
	// 对请求错误做些什么
	return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use((response) => {
	// 隐藏loading
	hideLoading()
	// 对响应数据做点什么
	return response;
}, (err) => {
	// 全局错误提示
	if (err.response && err.response.data && err.response.data.errorCode) {
		Message.error(err.response.data.msg)
	}
	// 隐藏loading
	hideLoading()
	// 对响应错误做点什么
	return Promise.reject(err);
});
Vue.prototype.ajax = function (url, params = {}) {
	return new Promise(function (resolve, reject) {
		let urls=url.split('/')[0]=='admin'?url:('/admin/pc/'+url)
		axios.post(urls, params, {
			headers: {
				token: window.sessionStorage.getItem('token')
			}
		}).then(function (response) {
			var d = [];
			d.push(response.data.code);
			d.push(response.data.code == 200 ? response.data.data : response.data.msg);
			for (var i in response.data) {
				d[i] = response.data[i];
			}
			resolve(d)
		}).catch(function (error) {
			Message.error('请求失败');
		});
	});
}

// 引入拖拽排序
import VueDND from 'awe-dnd'
Vue.use(VueDND)

// 引入全局配置文件
import $conf from "./common/config/config.js"
Vue.prototype.$conf = $conf


Vue.directive('auth', {
	inserted(el, binding, vnode, oldVnode) {
		let user = window.sessionStorage.getItem('user')
		user = user ? JSON.parse(user) : {}
		if (!user.super) {
			let rules = user.ruleNames ? user.ruleNames : []

			let v = rules.find(item => item === binding.value)
			if (!v) {
				el.parentNode.removeChild(el)
			}
		}
	}
})

Vue.config.productionTip = false

router.onError((error) => {
	const pattern = /Loading chunk (\d)+ failed/g;
	const isChunkLoadFailed = error.message.match(pattern);
	if (isChunkLoadFailed) {
		// 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
		location.reload();
		// const targetPath = $router.history.pending.fullPath;
		// $router.replace(targetPath);
	}

})
import openws from "./common/openws";
Vue.prototype.$openws = openws;

new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')